import React, { useContext, useEffect, useState } from "react";

import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";

import Swal from "sweetalert2";

import { useHistory } from "react-router-dom";

import TextFieldErp from "../../components/basics/TextFieldErp";
import DragAndDrop from "../../components/dragAndDrop/DragAndDrop";
import { validNotNull, validTypeFile } from "../../utils//validations";
import { updateCNDAgendaCliente } from "../../repository/ERP/pub/CNDAgendaClienteService";
import Title from "../../components/basics/Title";
import ButtonErp from "../../components/basics/ButtonErp";
import { notify } from "../../utils/notify";
import Loading from "../../components/basics/Loading";
import getBase64 from "../../utils/getBase64";
import { QueryParamsContext } from "../../context/QueryParamsContext";
import SelectErp from "../../components/basics/SelectErp";
import "./CND.css";

export default function CNDManual({ location }) {
  const [ambito, setAmbito] = useState("");
  const [tipoConsulta, setTipoConsulta] = useState("");
  const [cnd, setCnd] = useState("");
  const [inicioControle, setInicioControle] = useState("");
  const [emissao, setEmissao] = useState("");
  const [vencimento, setVencimento] = useState("");
  const [status, setStatus] = useState(null);
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { queryParams } = useContext(QueryParamsContext);
  const { goBack } = useHistory();

  useEffect(() => {
    if (!location || !location.state) return;

    const row = JSON.parse(location.state);

    setAmbito(row.ambito);
    setTipoConsulta(row.tipo_consulta);
    setCnd(row.cnd);
    setInicioControle(
      row.dataInicio ? row.dataInicio.split("/").reverse().join("-") : ""
    );

    setFile(null);
    setErrors({});
  }, [location]);

  const handleFile = async (files) => {
    if (
      !validTypeFile({
        file: files[0],
        types: ["pdf", "png", "jpg", "jpeg"],
      })
    ) {
      return notify("Só é permitido anexar PDF ou imagem.");
    }

    setFile(files[0]);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      setLoading(true);

      if (!location || !location.state) return;

      const row = JSON.parse(location.state);

      const resultValidation = validNotNull([
        { value: emissao, key: "emissao" },
        { value: status, key: "status" },
        { value: vencimento, key: "vencimento" },
        { value: file, key: "file" },
      ]);

      if (
        Object.prototype.toString.call(new Date(emissao)) !== "[object Date]" ||
        isNaN(new Date(emissao).getTime())
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.emissao =
          "A data de emissão informada é inválida.";
      } else if (Date.parse(emissao) > Date.parse(new Date())) {
        resultValidation.error = true;
        resultValidation.errorsValidation.emissao =
          "A data de emissão não pode ser futura.";
      }

      if (
        Object.prototype.toString.call(new Date(vencimento)) !==
          "[object Date]" ||
        isNaN(new Date(vencimento).getTime())
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.vencimento =
          "A data de vencimento informada é inválida.";
      } else if (Date.parse(vencimento) < Date.parse(new Date())) {
        resultValidation.error = true;
        resultValidation.errorsValidation.vencimento =
          "A data de vencimento deve ser futura.";
      }

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        return notify("Verifique se os campos estão preenchidos corretamente.");
      }

      const body = {
        data_emissao: emissao,
        data_vencimento: vencimento,
        cnd_file: null,
        status: status.descricao,
      };

      const fileBase64 = await getBase64(file);

      if (!fileBase64 || !fileBase64.includes("base64")) {
        setErrors({ file: "Arquivo inválido" });
        return notify(
          "Arquivo inválido. Verifique se o arquivo não está corrompido."
        );
      }

      if (fileBase64) {
        body.cnd_file = fileBase64;
      }

      const result = await updateCNDAgendaCliente(
        row.id,
        body,
        queryParams.empresa_cnpj
      );

      if (result && result.success) {
        Swal.fire({
          icon: "success",
          text: "Registro editado com sucesso.",
          showConfirmButton: true,
          timer: 3000,
        });

        sessionStorage.setItem("tabCNDPainel", 1);
        return goBack();
      }

      notify("Não foi possível editar o registro.");
    } catch (error) {
      notify("Não foi possível editar o registro.");
      console.error("ERROR CNDManual handleSubmit", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Loading open={loading} />
      <form onSubmit={handleSubmit}>
        <Grid container justify="center">
          <Grid
            item
            container
            spacing={2}
            xs={11}
            style={{
              background: "white",
              borderRadius: 10,
              marginTop: 20,
              padding: 5,
            }}
          >
            <Grid item xs={12}>
              <Title titulo="CND Manual" />
            </Grid>

            <Grid item lg={4} md={6} sm={12} xs={12}>
              <TextFieldErp
                disabled
                helperText={errors.ambito}
                error={errors.ambito ? true : false}
                label="Âmbito"
                lg={2}
                value={ambito}
                setValue={setAmbito}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={12} xs={12}>
              <TextFieldErp
                disabled
                helperText={errors.tipoConsulta}
                error={errors.tipoConsulta ? true : false}
                label="Tipo de Consulta"
                lg={2}
                value={tipoConsulta}
                setValue={setTipoConsulta}
              />
            </Grid>
            <Grid item lg={4} md={6} sm={12} xs={12}>
              <TextFieldErp
                disabled
                helperText={errors.cnd}
                error={errors.cnd ? true : false}
                label="CND"
                lg={2}
                value={cnd}
                setValue={setCnd}
              />
            </Grid>
            <Grid item lg={4} md={6} sm={12} xs={12}>
              <TextFieldErp
                disabled
                helperText={errors.inicioControle}
                error={errors.inicioControle ? true : false}
                label="Início Controle"
                type="date"
                value={inicioControle}
                setValue={setInicioControle}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item lg={4} md={6} sm={12} xs={12}>
              <TextFieldErp
                helperText={errors.emissao}
                error={errors.emissao ? true : false}
                label="Emissão*"
                type="date"
                value={emissao}
                setValue={setEmissao}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={12} xs={12}>
              <TextFieldErp
                helperText={errors.vencimento}
                error={errors.vencimento ? true : false}
                label="Vencimento*"
                type="date"
                value={vencimento}
                setValue={setVencimento}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={12} xs={12}>
              <SelectErp
                helperText={errors.status}
                error={errors.status ? true : false}
                label="Status"
                lg={2}
                value={status}
                setValue={setStatus}
                optionsList={[
                  { descricao: "Positiva" },
                  { descricao: "Negativa" },
                ]}
                descriptionField="descricao"
              />
            </Grid>

            <Grid item xs={12}>
              <label className="label-anexo">
                Anexo {errors.file && <label>{errors.file}</label>}
              </label>
              {file ? (
                <div className="container-card-file-upload">
                  <div>
                    <CloseIcon onClick={() => setFile(null)} />
                  </div>
                  <div className="type-file-card">
                    <h2>
                      {file.name
                        .split(".")
                        [file.name.split(".").length - 1].toUpperCase()}
                    </h2>
                  </div>
                  <div className="name-file-card">
                    <label>{file.name.substring(0, 10)}</label>
                  </div>
                </div>
              ) : (
                <DragAndDrop
                  handleFile={handleFile}
                  typesAccept="application/pdf, image/png, image/jpeg, image/jpg"
                ></DragAndDrop>
              )}
            </Grid>

            <Grid
              item
              md={12}
              container
              justify="flex-end"
              className="cnd-container-btns"
            >
              <ButtonErp
                cancel
                onClick={() => {
                  sessionStorage.setItem("tabCNDPainel", 1);
                  goBack();
                }}
              />
              <ButtonErp save type="submit" />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
